import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import styled from 'styled-components';
import { Flex } from '@rebass/grid';
import Text from '../../atoms/Text';
import Input from '../../atoms/Input';
import Button from '../../atoms/Button';
import { getCoupons, issueCoupon, redeemCoupon } from '../../../api/coupon';
import { getCouponTemplateId } from '../../../utils/common';
import { withLoading } from '../../../context/loading';
import { withAuth } from '../../../context/auth';

const Container = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 22px;
`;

class RedeemPage extends React.Component {
  constructor() {
    super();
    this.state = {
      coupon: null,
      redeemCode: '',
      error: null,
    };
  }

  setCoupon = (coupon) => {
    this.setState({ coupon });
  }

  setRedeemCode = (code) => {
    this.setState({ redeemCode: code });
  }

  setError = (err) => {
    this.setState({ error: err });
  }

  onSubmit = (value) => {
    const { auth, setAuth, setLoading } = this.props;
    const { coupon } = this.state;
    setLoading(true);
    return redeemCoupon(get(coupon, 'coupon_instance_id'), value, auth, setAuth)
      .then(({ data: updatedCoupon }) => {
        if (get(updatedCoupon, 'status') === 'redeemed') {
          const updatedUser = { ...auth.user, status: 'completed' };
          setAuth({ ...auth, user: updatedUser });
        }
      })
      .catch(err => {
        this.setError('Invalid Code');
      })
      .finally(() => setLoading(false));
  };

  componentDidMount() {
    const { appType, auth, setAuth, setLoading } = this.props;
    const couponTemplateId = getCouponTemplateId(appType);
    const params = {
      owner_id: get(auth, 'user.username'),
      coupon_template: couponTemplateId,
    };
    setLoading(true);
    getCoupons(params, auth, setAuth)
      .then(({ data: coupons }) => {
        if (get(coupons, 0)) {
          this.setCoupon(get(coupons, 0));
        } else {
          return issueCoupon(couponTemplateId, this.props.auth, setAuth) // get the updated auth if token is refreshed
            .then(({ data }) => {
              this.setCoupon(data);
            });
        }
      })
      .catch((err) => alert(err.message))
      .finally(() => setLoading(false));
  }

  render() {
    const { redeemCode, coupon, error } = this.state;
    return (
      <Container>
        <Text variant="h2" align="center">工作人員輸入密碼</Text>
        <Flex mt="0.8rem" flexDirection="column" alignItems="center">
          <Input
            value={redeemCode}
            invalid={!!error}
            onChange={(val) => {
              this.setError(null);
              this.setRedeemCode(val);
            }}
          />
          {/* {error && <Text palette="secondary">{error}</Text>} */}
        </Flex>
        <Flex mt="1rem">
          <Button color="tertiary" onClick={() => this.onSubmit(redeemCode)} disabled={!coupon}>
            <Text palette="secondary" variant="h3">提交</Text>
          </Button>
        </Flex>
        <Flex justifyContent="flex-end" width={1} mt="auto">
          <Text fontType="tertiary" variant="body2">*條款及細則適用</Text>
        </Flex>
      </Container>
    );
  }
}

RedeemPage.propTypes = {
  appType: PropTypes.string,
  auth: PropTypes.object,
  setAuth: PropTypes.func,
  setLoading: PropTypes.func,
};

RedeemPage.defaultProps = {
  appType: 'kolour_tw',
  auth: null,
  setAuth: () => {},
  setLoading: () => {},
};

export default withAuth(withLoading(RedeemPage));
